import { t } from 'i18next';
import useCurrentCountry from 'hooks/useCurrentCountry';
import { AC } from 'settings/form';
import { Field } from './field';

const { isFr } = useCurrentCountry();

export const editDeliveryAddressFormFields: Record<string, Field> = {
  street: {
    name: 'street',
    label: t('LABEL_NAME_WAY'),
    required: true,
    autoComplete: AC.StreetAddress,
  },
  ...(isFr && {
    nameComplement: {
      name: 'nameComplement',
      label: t('LABEL_BUILDING_COMPLEMENT'),
      autoComplete: AC.Off,
    },
  }),
  nameAddress: {
    name: 'nameAddress',
    label: t('LABEL_BUILDING'),
    autoComplete: AC.Off,
  },
  saidPlace: {
    name: 'saidPlace',
    label: t('LABEL_LOCALITY'),
    autoComplete: AC.Off,
  },
  city: {
    name: 'city',
    label: t('LABEL_CITY'),
    required: true,
    autoComplete: AC.City,
  },
  postalCode: {
    name: 'postalCode',
    label: t('LABEL_POSTCODE'),
    required: true,
    autoComplete: AC.PostalCode,
    validation: isFr ? 'number' : undefined,
  },
  country: {
    name: 'country',
    label: t('LABEL_COUNTRY'),
    required: true,
    disabled: true,
    autoComplete: AC.Country,
  },
};
